import React, { useState, useCallback } from 'react';
import Modal from '../../Common/Modal/Modal';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';

interface OpeningDateModalProps {
    onCancel: () => void;
    onComplete: (openingDate: string) => void;
}

const OpeningDateModal: React.FC<OpeningDateModalProps> = ({ onCancel, onComplete }) => {
    const [openingDate, setOpeningDate] = useState<string>(Moment.utc(new Date()).format(DATE_FORMAT));

    const onChange = useCallback((date: string) => {
        setOpeningDate(date);
    }, []);

    const handleComplete = useCallback(() => {
        onComplete(openingDate);
    }, [onComplete, openingDate]);

    const renderBody = () => (
        <div>
            <div>Please select an Opening/Zero Date so we can preview your Baseline Tasks properly in the Gantt Chart. You can change this later.</div>
            <div className="mt-3 mb-3">
                <DatePicker
                    value={openingDate}
                    name="openingDate"
                    label="Opening/Zero Date"
                    onChange={onChange}
                />
            </div>
        </div>
    );

    return (
        <Modal
            id="selectOpeningDate"
            title="Select Opening/Zero Date"
            body={renderBody()}
            onCloseClick={onCancel}
            onPrimaryClick={handleComplete}
            onSecondaryClick={onCancel}
        />
    );
};

export default OpeningDateModal;
